import APIV3 from '../../../api/axios/APIV3';

export const fetchImageList = async (imageType, setState) => {
    setState((prevState) => ({
        ...prevState,
        isLoading: true,
    }));

    let response;
    try {
        // response = await APIV3.get(`restaurants/:restaurantId/images`);
        response = await APIV3.get(`restaurants/:restaurantId/images?image_type=${imageType}`);

        setState((prevState) => ({
            ...prevState,
            isLoading: false,
        }));
        if (response?.success) {
            setState((prevState) => ({
                ...prevState,
                images: [...response?.uploads],
            }));
        }
    } catch (error) {
        response = error;
        setState((prevState) => ({
            ...prevState,
            isLoading: false,
        }));
    }

    return response;
};
